module.exports = __webpack_public_path__ + "assets/media/level-08.61daa53a.png";